import { translate } from 'utils/translate';

export const getFileName = (route) => 
{
  var file = splitUrlName(route.url);

  if(!!route.name && !!route.name.length)
    return route.name + ` (${file.ending.toUpperCase()})`;

  return file.ending.toLowerCase() === "pdf"
    ? file.name + ` (${file.ending.toUpperCase()})`
    : translate('/product/route');
}

export const splitUrlName = (url) => {
    let splitUrl = url.split('.');
    let fileEnding = splitUrl[splitUrl.length - 1];
    let splitName = splitUrl[splitUrl.length - 2].split('/');
    let fileName = splitName[splitName.length - 1];

    return {
        name: fileName,
        ending: fileEnding
    };
}
